import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';


@Component({
  selector: 'emm-duplicate-item-dialog',
  templateUrl: './duplicate-item-dialog.component.html',
  styleUrls: ['./duplicate-item-dialog.component.scss']
})
export class DuplicateItemDialogComponent implements OnInit {

    form;
    newTag;

  constructor(
      public dialogRef: MatDialogRef<DuplicateItemDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      ) { }

  ngOnInit(): void {
      this.buildForm();
  }

  duplicateItem(): void {
      this.newTag = this.form.get('tag').value;
  }

  closeAfterSubmit(): void {
      const result = {
          newTag: this.newTag,
          duplicatedItem: this.data.item,
        };
      this.dialogRef.close(result);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    buildForm(): void {
        this.form = new FormGroup({
            tag: new FormControl(''),
        });
    }

    OnSubmit(): void {
        if (this.form.valid) {
            this.duplicateItem();
            this.closeAfterSubmit();
        }
    }

}
